<div class="bg-white rounded-[10px] flex flex-col overflow-hidden">
  <div class="flex items-center justify-between px-5 py-[15px]">
    <span class="fg-noir-2 text-[14px] font-medium">
      {{ 'admin_settings.check_in.label' | translate }}
    </span>
    <button type="button" (click)="toggleCheckInMode()"
      class="relative h-[28px] w-[56px] rounded-full flex items-center transition-colors cursor-pointer px-[3px]"
      [class.bg-vert-1]="checkInEnabled()" [class.bg-gris-3]="!checkInEnabled()"
      [class.justify-end]="checkInEnabled()" [class.justify-start]="!checkInEnabled()">
      <span class="size-[22px] rounded-full bg-white shrink-0 shadow"></span>
    </button>
  </div>
</div>
